export const actionTypes = {
    SUPPORT_TICKET_SUBMIT: 'SUPPORT_TICKET_SUBMIT',
    SUPPORT_TICKET_SUCCESS: 'SUPPORT_TICKET_SUCCESS',
    SUPPORT_TICKET_ERROR: 'SUPPORT_TICKET_ERROR',
}

export function sendSupportTicket(formData) {
    return {
        type: actionTypes.SUPPORT_TICKET_SUBMIT,
        payload: {
            request: {
                url: '/api/communication/support/',
                method: 'POST',
                data: formData,
            },
            client: 'support', // 👈 links to the client you just added
        },
    }
}

